import Employees from '../SuperAdmin/Employees';
export default Employees;
